module.exports = __webpack_public_path__ + "static/media/keyshot.c56f5477.png";